import { RgDataSetID } from '../../data/rg-data-set-id.js';
import { RG_TYPE } from '../../types/rg-type.js';

const DefaultWorld = {
    type: RG_TYPE.World,
    data: {
        dataset: RgDataSetID.uk_01,
        coords: { latitude: 0, longitude: 0 }
    },
    children: []
};

export { DefaultWorld };
//# sourceMappingURL=default-world.js.map
